// removed by extract-text-webpack-plugin
module.exports = {"icon":"BuyerAssurance-style__icon__c9947d0","title":"BuyerAssurance-style__title__c9947d0"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/BuyerAssurance/BuyerAssurance-style.scss
// module id = 3460
// module chunks = 4